import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
 import ScrollToTop from'./components/ScrollToTop';

// Import pages
import Homepage from './pages/homepage';
 import LegalAreasLanding from'./pages/legal-areas-landing';
 import ForLawyers from'./pages/for-lawyers';
 import AboutUs from'./pages/about-us';
 import Contact from'./pages/contact';
 import TrustCenter from'./pages/trust-center';
 import LegalCompliance from'./pages/legal-compliance';
 import NotFound from'./pages/NotFound';
import Impressum from './pages/impressum';
import Datenschutz from './pages/datenschutz';

// Import auth components
import Login from './components/auth/Login';
 import Signup from'./components/auth/Signup';
 import Dashboard from'./components/Dashboard';

function Routes() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/" element={<Homepage />} />
          <Route path="/homepage" element={<Homepage />} />
          <Route path="/legal-areas-landing" element={<LegalAreasLanding />} />
          <Route path="/legal-areas" element={<LegalAreasLanding />} />
          <Route path="/for-lawyers" element={<ForLawyers />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/trust-center" element={<TrustCenter />} />
          <Route path="/legal-compliance" element={<LegalCompliance />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          
          {/* Auth routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/dashboard" element={<Dashboard />} />
          
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  )
}

export default Routes